module.exports = __webpack_public_path__ + "static/media/shopee-pay-logo.a6cbe6a3.png";